export enum SpaceTokenType {
  None = 'space-0',
  Hairline = 'space-px',
  Xs = 'space-0-5',
  Sm = 'space-1',
  SmPlus = 'space-1-5',
  Md = 'space-2',
  Lg = 'space-3',
  Xl = 'space-4',
  Xl2 = 'space-5',
  Xl3 = 'space-6',
  Xl4 = 'space-8',
  Xl5 = 'space-9',
}
